import React from 'react'
import { Table } from 'antd'
import { useTranslation } from 'react-i18next'
import { moment } from '@BUP/configs/i18n'
import BupSpinner from '@BUP/components/Loading/Spinner'
import AlertComponent from '@BUP/components/Generics/Alert'

/**
 * Shows what each student actually answered for a course-assignment period: their name, the
 * classmates they picked, and when. Counselor-only - there was previously no way to see this
 * without querying the database directly.
 */
const PreferencesTable = ({ isLoading, error, preferences }) => {
  const [t] = useTranslation('translation', { keyPrefix: 'pages.data.courseAssignmentPeriodDashboard' })

  if (isLoading) return <BupSpinner size='large' />

  if (error) {
    return (
      <AlertComponent
        type='error'
        messageKey='common.resources.course-assignment.actions.read.failure'
        error={error}
      />
    )
  }

  if (!preferences.length) {
    return <p>{t('noPreferencesYet')}</p>
  }

  const columns = [
    {
      title: t('columnStudent'),
      dataIndex: 'studentName',
      key: 'studentName'
    },
    {
      title: t('columnClassmates'),
      dataIndex: 'classmates',
      key: 'classmates',
      render: classmates => classmates.map(classmate => classmate.name).filter(Boolean).join(', ')
    },
    {
      title: t('columnSubmittedAt'),
      dataIndex: 'submittedAt',
      key: 'submittedAt',
      render: submittedAt => submittedAt ? moment(submittedAt).format('lll') : '-'
    }
  ]

  return (
    <Table
      rowKey='enrollmentId'
      columns={columns}
      dataSource={preferences}
      pagination={false}
    />
  )
}

export default PreferencesTable
